import { render, staticRenderFns } from "./list.vue?vue&type=template&id=0686185d&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0686185d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0686185d')) {
      api.createRecord('0686185d', component.options)
    } else {
      api.reload('0686185d', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=0686185d&scoped=true", function () {
      api.rerender('0686185d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/placeholder/list.vue"
export default component.exports